import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { PageChangeEvent } from '@progress/kendo-angular-grid';
import * as moment from 'moment';
import { UserWebViewModel } from 'src/app/models/User';
import { ServerService } from 'src/app/services/server/server.service';

@Component({
    selector: 'app-user-list',
    templateUrl: './user-list.component.html',
    styleUrls: ['./user-list.component.scss'],
    standalone: false
})
export class UserListComponent {
  items: Array<any> = [];
  filteredItems: Array<any> = [];
  searchTerm = '';
  lastSeenFilter = 'all';
  skip = 0;
  readonly defaultUserImage = 'assets/images/static/user.png';

  constructor(private server: ServerService, private router: Router) {
    this.server.onGetAllAppUsers().subscribe({
      next: (res) => {
        if (res.success === true) {
          const json = JSON.stringify(res.obj);
          this.items = <UserWebViewModel[]>JSON.parse(json);
          this.items = this.items.map((u: UserWebViewModel) => ({
            ...u,
            profilePicture: this.server.ProcessProfilePicUrl(u.profilePicture, false, true),
          }));
          this.applyFilters();
        }
      },
      error: (err) => {},
    });
  }

  onSearchChange() {
    this.applyFilters();
  }

  onLastSeenFilterChange() {
    this.applyFilters();
  }

  applyFilters() {
    const term = this.searchTerm.trim().toLowerCase();
    this.filteredItems = this.items.filter((item: UserWebViewModel) => {
      const values = [
        item.firstName,
        item.lastName,
        item.userName,
        item.email,
        item.mobileNo,
      ];

      const matchesSearch =
        !term ||
        values.some((value) => (value || '').toString().toLowerCase().includes(term));

      const matchesLastSeen = this.matchesLastSeenFilter(item.lastSeenTs);
      return matchesSearch && matchesLastSeen;
    });

    // Reset paging so filters always apply from first page.
    this.skip = 0;
  }

  onPageChange(event: PageChangeEvent) {
    this.skip = event.skip;
  }

  matchesLastSeenFilter(lastSeenTs: string | null | undefined) {
    if (this.lastSeenFilter === 'all') {
      return true;
    }

    const parsed = lastSeenTs ? moment(lastSeenTs) : null;
    const isValid = !!parsed && parsed.isValid();

    if (this.lastSeenFilter === 'never') {
      return !isValid;
    }

    if (!isValid) {
      return false;
    }

    const now = moment();
    if (this.lastSeenFilter === '24h') {
      return now.diff(parsed, 'hours') <= 24;
    }
    if (this.lastSeenFilter === '7d') {
      return now.diff(parsed, 'days') <= 7;
    }
    if (this.lastSeenFilter === '30d') {
      return now.diff(parsed, 'days') <= 30;
    }

    return true;
  }

  onImageError(event: Event) {
    const img = event.target as HTMLImageElement;
    img.src = this.defaultUserImage;
  }

  getActiveStatusClass(value: boolean) {
    return value ? 'status-badge active' : 'status-badge inactive';
  }

  formatLastSeen(value: string | null | undefined) {
    if (!value) {
      return 'Not available';
    }

    const parsed = moment(value);
    if (!parsed.isValid()) {
      return 'Not available';
    }

    return parsed.fromNow();
  }

  showUserDetails(userItem: UserWebViewModel) {
    this.router.navigateByUrl('main/users/detail', {
      state: { user: userItem },
    });
  }
}
